import React, { Component } from 'react';
import Switch from "react-switch";
import { Popover, OverlayTrigger } from "react-bootstrap";
import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';

import { toast } from 'react-toastify';

import { NoAceptar, AprobarNotas } from "../../../funciones/NotasCertificadasFunction";
import NotasCertificadas from "../../../components/Reportes/NotasCertificadasNew";
import { UrlImg } from '../../../shared/Url';
import ModalReportsEdit from '../../../components/Reportes/ModalReportsEdit';
import ReportEdit from '../../../components/Reportes/ReportEdit';

let tipoNota = 0;
let tipoNum = 0;
let deudaTSolic = "";

let UcGral = 0;
let HorasGral = 0;
let promedioGral = 0
let aprobadosGral = 0
let reprobadosGral = 0;
const ELECTIVA = "ELECTIVA";

let aprobadosGral_2 = 0
let reprobadosGral_2 = 0;
let PromAcum = [];

class NotasPendientes extends Component {
    state = {
        openCancel: false,
        openOk: false,
        openOkE: false,
        openReporte: false,
        openReporteE: false,
        modalBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        modalBtn1E: {
            icon:"fa fa-check",
            text: "Si"
        },
        check: true,
        dataRep: "",
    }

    change = () => {
        this.setState({
            check: !this.state.check
        })
    }

    modalCancel = () => {
        const { openCancel, modalBtn1 } = this.state;
        let tipoN = "Certificadas";
        if(tipoNota === 0) tipoN = "Simples"

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas realmente <strong className="text-danger">Cancelar</strong> esta solicitud de Notas {tipoN}?</div>
                <div style={{fontSize: 11}}>Se le enviará un Email de notificación al estudiante</div>
            </React.Fragment>
        )

        let noAceptar = (id) => () => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                NoAceptar (id, () => {
                    this.setState({
                        openCancel: false,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                    }, () => {
                        this.props.updateList();
                        toast.info("Has cancelado correctamente la solicitud",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openCancel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(this.props.datos.id)}
            />
        );
    }

    modalReporte = () => {
        const { openReporte, dataRep } = this.state;
        
        if (openReporte === false) return null;

        let { datos, fecha } = this.props;

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }
        
        let contenidoModal = () => (
            <NotasCertificadas
                fecha = {fecha}
                estData = {dataRep.estudiante}
                autData = {dataRep.director}
                ctrolData = {dataRep.ctrEstudios}
                historico = {dataRep.historico}
                materias = {dataRep.materias}
                carrera = {dataRep.carrera}
                uc = {dataRep.uc}
                tipo = {tipoNota}
            />
        )

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo={`Notas Certificadas de ${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}`}
                display= "block"
                cerrar = {() => {
                    this.setState({
                        openReporte:false
                    }, () => {
                        /* this.props.updateList(); */
                    })
                }}
            />
        )
    }

    modalReporteE = () => {
        const { openReporteE, dataRep } = this.state;
        if (openReporteE === false) return null;

        let { datos, fecha } = this.props;

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let semestreL = (num) => {
            switch(num){
                case 1: return "PRIMER SEMESTRE"
                case 2: return "SEGUNDO SEMESTRE"
                case 3: return "TERCER SEMESTRE"
                case 4: return "CUARTO SEMESTRE"
                case 5: return "QUINTO SEMESTRE"
                case 6: return "SEXTO SEMESTRE"
                default: return null;
            }
        }

        let cintillo = `<p style="text-align:center; top: 30px"><img src = "${UrlImg}logo_menu_black.png" alt = "logo" height = "100px"></p>`;
        let membrete = `<p style="text-align:center"><span style="font-size:16px"><strong><span style="color:#000000">INSTITUTO UNIVERSITARIO DE DISE&Ntilde;O LAS MERCEDES</span></strong></span></p>
                            <p style="text-align:center"><span style="color:#000000"><span style="font-size:14px">M.E. N&ordm; 130 G.O. N&ordm; 36.719 9 JUNIO 1.999</span></span></p>`
                
        let semestreContent  = (semestre) => {
            let historico = dataRep.historico;
            let materias = dataRep.materias;

            let matContent = 0;
            let matSemestre = materias.filter(sem => sem.semestre_num === semestre);
            matSemestre.forEach(option => {
                let histB = historico.find(resut => resut.id === option.id)
                if (histB !== undefined) matContent++;
            })

            let mTop = 0;
            let totalHoras = 0;
            let totalUc = 0;
            let matAprobadas = 0
            let matReprobadas = 0
            let subPromedio = 0

            let matAprobadas_2 = 0
            let matReprobadas_2 = 0

            let notaNum = (nota) => {
                if (nota.length === 1) return `0${nota}`
                return nota
            }

            let notaLetras = (nota) => {
                let letras =    ["UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                                "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                                "DIECINUEVE", "VEINTE"]
                return (letras[nota - 1])
            }

            let promedio = (subpromedio, ap, rep) => {
                let cant = ap + rep;
                if (cant === 0 ) return null;
                promedioGral += (parseInt(subpromedio))
                let promedio = (subpromedio / cant).toFixed(2)
                if ((promedio % 1) === 0) return (subpromedio / cant);

                return promedio
            }

            let periodo = (num, mes, yyyy) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
                if (num === parseInt(mes)) return (`${meses[mes - 1]} ${yyyy}`)
            }

            let tipoSA = (nota, min, tipo) => {
                switch (tipo) {
                    case "PRESENCIAL":
                        if (parseInt(nota) < parseInt(min)) return "R"
                        return "A"
                    case "PRUEBA DE SUFICIENCIA":
                        if (parseInt(nota) < parseInt(min)) return "RS"
                        return "AS"
                    case "VERANO":
                        if (parseInt(nota) < parseInt(min)) return "RCV"
                        return "ACV"
                    default:
                        return "RT"
                }
            }

            let matariasContent = () => {
                let materiasSem = "";
                let numMat = 0;

                let llenaMateriaSem = (corte1, corte2, corte3, codigo, nombre, prelacion1, prelacion2, horas, uc, tiposa, nota, nLetras, modalidad) => {
                    numMat++;

                    let notaCuad = (mod, color) => {
                        let notaC = "APROBADO";
                        if (nota === "02") notaC = "REPROBADO";
                        if (mod === 0) return `<td colspan="2" rowspan="1" style="text-align:center; background-color: ${color}"><span style="font-size:11px">${notaC}</span></td>`

                        return `<td style="text-align:center; background-color: ${color}"><span style="font-size:11px">${nota}</span></td>
                        <td style="text-align:center; background-color: ${color}"><span style="font-size:11px">${nLetras}</span></td>`
                    }

                    let periodo = () => {
                        switch(true){
                            case (corte1 !== undefined && corte1 !== ""): return corte1
                            case (corte2 !== undefined && corte2 !== ""): return corte2
                            case (corte3 !== undefined && corte3 !== ""): return corte3
                            default: return null
                        }
                    }

                    let color = "#ffffff"
                    if (numMat%2 === 0) color = "#f7f7f7"

                    materiasSem += `
                        <tr style = "">
                            <td style="text-align:center; background-color: ${color}"><span style="font-size:11px">${codigo}</span></td>
                            <td style = "background-color: ${color}"><span style="font-size:11px">${nombre}</span></td>
                            <td style="text-align:center; background-color: ${color}"><span style="font-size:11px">${periodo()}</span></td>
                            ${notaCuad(modalidad, color)}
                        </tr>`
                }

                for (let i in materias){
                    let matHist = 0;
                    if (materias[i].semestre_num === semestre){
                        for (let n in historico) {
                            if (historico[n].codigo === materias[i].codigo){
                                matHist++;
    
                                /* Totales del semestre */
                                mTop += 3;
                                totalHoras += parseInt(historico[n].horas);
                                totalUc += parseInt(historico[n].u_c);
                                subPromedio += (parseInt(historico[n].nota)/*  * parseInt(historico[n].u_c) */) 
    
                                /* Totales Globales */
                                HorasGral += parseInt(historico[n].horas);
                                UcGral += parseInt(historico[n].u_c);
    
                                /* MATERIAS CUALITATIVAS */
                                if (notaNum(historico[n].nota) === "01" && historico[n].cuantitativo === 0){
                                    matAprobadas++;
                                    aprobadosGral++;
                                }
    
                                if (parseInt(historico[n].nota) >= parseInt(historico[n].nota_min)){
                                    matAprobadas++;
                                    aprobadosGral++;
    
                                    matAprobadas_2++;
                                    aprobadosGral_2++;
                                }
    
                                if (parseInt(historico[n].nota) < parseInt(historico[n].nota_min)){
                                    
                                    if (historico[n].cuantitativo === 1){
                                        matReprobadas++;
                                        reprobadosGral++;
    
                                        matReprobadas_2++;
                                        reprobadosGral_2++;
                                    }else{
                                        if (historico[n].nota === "2") {
                                            matReprobadas++;
                                            reprobadosGral++;  
                                        }
                                    }
                                }
    
                                llenaMateriaSem (
                                    periodo(1, historico[n].corte_name, historico[n].corte_year),
                                    periodo(6, historico[n].corte_name, historico[n].corte_year),
                                    periodo(8, historico[n].corte_name, historico[n].corte_year),
                                    historico[n].codigo,
                                    historico[n].materia_name,
                                    historico[n].prelacion_1,
                                    historico[n].prelacion_2,
                                    historico[n].horas,
                                    historico[n].u_c,
                                    tipoSA(historico[n].nota, historico[n].nota_min, historico[n].tipoev_name),
                                    notaNum(historico[n].nota),
                                    notaLetras(historico[n].nota),
                                    historico[n].cuantitativo
                                )
                            }
                        }

                        let search = (materias[i].materia_name).indexOf(ELECTIVA);
                        if (search === 0) {
                            /* PARA LAS MATERIAS ELECTIVAS */

                            let cant = 0;
                            for (let n in historico) {
                                if (parseInt(historico[n].electiva) === materias[i].id){
                                    
                                    /* Totales del semestre */
                                    mTop += 3;
                                    totalHoras += parseInt(historico[n].horas);
                                    totalUc += parseInt(historico[n].u_c);
                                    subPromedio += (parseInt(historico[n].nota)/*  * parseInt(historico[n].u_c) */) 

                                    /* Totales Globales */
                                    HorasGral += parseInt(historico[n].horas);
                                    UcGral += parseInt(historico[n].u_c);

                                    /* Totales */
                                    if (parseInt(historico[n].nota) >= parseInt(historico[n].nota_min)){
                                        matAprobadas++;
                                        aprobadosGral++;

                                        matAprobadas_2++;
                                        aprobadosGral_2++;
                                    }

                                    if (parseInt(historico[n].nota) < parseInt(historico[n].nota_min)){
                                        if (historico[n].cuantitativo === 1){
                                            matReprobadas++;
                                            reprobadosGral++;

                                            matReprobadas_2++;
                                            reprobadosGral_2++;
                                        }else{
                                            if (historico[n].nota === "2") {
                                                matReprobadas++;
                                                reprobadosGral++;  
                                            }
                                        }
                                    }
                                    
                                    cant ++;
                                    if (matHist === 0) {
                                        mTop += 3;
                                        llenaMateriaSem (
                                            periodo(1, historico[n].corte_name, historico[n].corte_year),
                                            periodo(6, historico[n].corte_name, historico[n].corte_year),
                                            periodo(8, historico[n].corte_name, historico[n].corte_year),
                                            historico[n].codigo,
                                            `${materias[i].materia_name} (${historico[n].materia_name})`,
                                            historico[n].prelacion_1,
                                            historico[n].prelacion_2,
                                            historico[n].horas,
                                            historico[n].u_c,
                                            tipoSA(historico[n].nota, historico[n].nota_min, historico[n].tipoev_name),
                                            notaNum(historico[n].nota),
                                            notaLetras(historico[n].nota),
                                            historico[n].cuantitativo
                                        )
                                    }
                                }
                            }
                            /* Si no ha cursado la electiva */
                            if (cant === 0){
                                if (matHist === 0) {
                                    mTop += 3;
                                    llenaMateriaSem ("", "", "",
                                        materias[i].codigo,
                                        `${materias[i].materia_name} ()`,
                                        materias[i].prelacion_1,
                                        materias[i].prelacion_2,
                                        "", "", "", "", "", ""
                                    )
                                }
                            }
                        /* Resto de las asignaturas */
                        }else{
                            if (matHist === 0) {
                                mTop += 3;
                                llenaMateriaSem ("", "", "",
                                    materias[i].codigo,
                                    materias[i].materia_name,
                                    materias[i].prelacion_1,
                                    materias[i].prelacion_2,
                                    "", "", "", "", "", ""
                                )
                            }
                        }
                    }
                }
                
                PromAcum.push(promedio(subPromedio, matAprobadas_2, matReprobadas_2))
                return materiasSem
            }

            let breaks = () => {
                if (semestre === 3 || semestre === 5) {
                    return (`
                        <p style="text-align:center">&nbsp;</p>
                        <div style="page-break-after:always"><span style="display:none">&nbsp;</span></div>
                        <p style="text-align:center">&nbsp;</p>${cintillo}
                        ${membrete}<p style="text-align:center">&nbsp;</p>`
                    )
                }

                return ``;
            }

            if (matContent === 0) return ``;

            return `
                ${breaks()}
                <p style="text-align:center"><span style="font-size:18px"><strong><span style="color:#000000">${semestreL(semestre)}</span></strong></span></p>
                <table border="1" cellpadding="2.5" cellspacing="0" class="custom-table" style="border-color: #dfdfdf; width:100%">
                    <thead>
                        <tr class = "custom-th">
                            <th scope="col" style="background-color: #dfdfdf; width: 14%;"><span style="color:#000000"><span style="font-size:12px">C&Oacute;DIGO</span></span></th>
                            <th scope="col" style="background-color: #dfdfdf; width: 50%;"><span style="color:#000000"><span style="font-size:12px">ASIGNATURA</span></span></th>
                            <th scope="col" style="background-color: #dfdfdf; width: 15%;"><span style="color:#000000"><span style="font-size:12px"><span style="line-height: 12px;">PERIODO ACAD&Eacute;MICO</span></span></span></th>
                            <th scope="col" style="background-color: #dfdfdf; width: 8%;"><span style="color:#000000"><span style="font-size:12px">NOTA</span></span></th>
                            <th scope="col" style="background-color: #dfdfdf; width: 13%;"><span style="color:#000000"><span style="font-size:12px">LETRAS</span></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        ${matariasContent()}
                    </tbody>
                </table>
            `
        }

        let tipoFirmante = (tipo) => {
            if (tipo === 1) return "DIRECTORA"
            if (tipo === 0) return "JEFE CONTROL DE ESTUDIOS"
        }

        let nombreAut = (tipo) => {
            if (tipo === 1) return `${(dataRep.director).aut_name} ${(dataRep.director).aut_ape}`;
            return `${(dataRep.ctrEstudios).aut_name} ${(dataRep.ctrEstudios).aut_ape}`;
        }

        let ciAut = (tipo) => {
            if (tipo === 1) return (dataRep.director).cedula;
            return (dataRep.ctrEstudios).cedula; 
        }

        let proG = () => {
            let prom = 0;
            PromAcum.forEach(option => {
                prom += parseFloat(option);
            })

            return((prom / PromAcum.length).toFixed(2));
        }

        let fechaD = () => {
            let diaActual = new Date(fecha);
            let day = diaActual.getDate();
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            let month = meses[diaActual.getMonth()];
            let year = diaActual.getFullYear();
        
            return `${day} días del mes de ${month} de ${year}`
        }

        let contenidoHtml = () => {
            let contenido = "";
            
            let memLog = `<p style="text-align:center">&nbsp;</p>
                <div style="page-break-after:always"><span style="display:none">&nbsp;</span></div>
                <p style="text-align:center">&nbsp;</p>${cintillo}
            ${membrete}<p style="text-align:center">&nbsp;</p>`
            let parrafo1 = `<p style="text-align:justify"><span style="font-size:14px"><span style="color:#000000">Quien suscribe, ${nombreAut(tipoNum)}, titular de la C&eacute;dula de Identidad V-${ciAut(tipoNum)} ${tipoFirmante(tipoNum)} del Instituto Universitario De Dise&ntilde;o Las Mercedes, certifica que el (la) ciudadano (a):</span></span></p>`;
            let estudiante = `<p style="text-align:center"><span style="color:#000000"><span style="font-size:26px"><strong>${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</strong></span></span></p>`;
            let parrafo2 = `<p style="text-align:justify"><span style="color:#000000"><span style="font-size:14px">Titular de la C&eacute;dula de Identidad ${dataRep.estudiante.nacionalidad} ${dataRep.estudiante.ci}, curs&oacute; en este Instituto Universitario las asignaturas que a continuaci&oacute;n se indican con sus respectivas calificaciones:</span></span></p>`;
            let carrera = `<p style="text-align:justify"><span style="color:#000000"><span style="font-size:14px">Carrera: ${dataRep.carrera.carrera_name}</span></span></p>`;
            let rendimiento = `<p><strong><span style="color:#000000"><span style="font-size:14px">El &iacute;ndice de rendimiento acad&eacute;mico es de PROMGRAL puntos.</span></span></strong></p>`;
            let parrafo3 = `<p style="text-align:justify"><span style="color:#000000"><span style="font-size:14px">Se expide la presente Certificaci&oacute;n a favor de el (la) ciudadano (a) <strong>${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</strong> titular de la C&eacute;dula de Identidad <strong>V 27784391</strong>, en Caracas, a los ${fechaD()}.</span></span></p>`;
            let autName = `<p style="text-align:center"><strong><span style="font-size:18px"><span style="color:#000000">${nombreAut(tipoNum)}</span></span></strong></p>
            <p style="text-align:center"><span style="font-size:12px"><span style="color:#000000">${tipoFirmante(tipoNum)}</span></span></p>`;
            let observaciones = `<p><span style="font-size:14px"><strong>OBSERVACIONES:</strong></span></p>
                <p>Este documento consta de NUMPAG p&aacute;ginas.</p>
                <p>La escala de calificaciones es de uno (1) a&nbsp; veinte (20) puntos.</p>
                <p>La nota m&iacute;nima aprobatoria es de diez (10) puntos.</p>`;

            contenido = `<p style="text-align:center">&nbsp;</p>${cintillo}
                        ${membrete}<p style="text-align:center">&nbsp;</p>
                        ${parrafo1}
                        ${estudiante}
                        ${parrafo2}
                        ${carrera}
                        ${semestreContent(1)}
                        ${semestreContent(2)}
                        ${semestreContent(3)}
                        ${semestreContent(4)}
                        ${semestreContent(5)}
                        ${semestreContent(6)}
                        ${memLog}
                        ${rendimiento}
                        ${parrafo3}
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        ${autName}
                        <p>&nbsp;</p>
                        ${observaciones}`;

            return contenido;
        };

        let contenidoModal = () => (
            <ReportEdit
                titulo={`Notas Certificadas de ${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}`}
                dataHtml = {contenidoHtml()}
                prom = {proG()}
                cerrar = {() => {
                    this.setState({
                        openReporteE:false
                    })
                }}
            />
        )

        return (
            <ModalReportsEdit
                footer = {false}
                reporte={contenidoModal()}
                titulo={`Notas Certificadas de ${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}`}
                display= "block"
                cerrar = {() => {
                    this.setState({
                        openReporteE:false
                    }, () => {
                        /* this.props.updateList(); */
                    })
                }}
            />
        )
    }

    modalOk = () => {
        const { openOk, modalBtn1, check } = this.state;

        let tipoN = "Certificadas";
        if(tipoNota === 0) tipoN = "Simples"

        let Aceptar = (id) => () => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Generando el Formato"
                }
            }, () => {
                AprobarNotas (id, check, (resp) => {
                    this.setState({
                        check: true,
                        openOk: false,
                        openReporte: true,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                        dataRep: resp
                    }, () => {
                        /* this.props.updateList(); */
                    })
                })
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de Notas {tipoN}. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                <Switch height={12} onChange={this.change} width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openOk}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(this.props.datos.id)}
            />
        );
    }

    modalOkE = () => {
        const { openOkE, modalBtn1E, check } = this.state;
        let tipoN = "Certificadas";
        if(tipoNota === 0) tipoN = "Simples"

        let Aceptar = (id) => () => {
            this.setState({
                modalBtn1E: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Generando el Formato"
                }
            }, () => {
                AprobarNotas (id, check, (resp) => {
                    this.setState({
                        check: true,
                        openOkE: false,
                        openReporteE: true,
                        modalBtn1E: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                        dataRep: resp
                    }, () => {
                        /* this.props.updateList(); */
                    })
                })
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de Notas {tipoN}. Si presionas <strong>Si</strong> se cargará el formato para <strong>Editar</strong>. ¿Deseas continuar?</div>
                <Switch height={12} onChange={this.change} width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1E.icon}></i> {modalBtn1E.text}</React.Fragment>}
                large = "medium"
                isopen =  {openOkE}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(this.props.datos.id)}
            />
        );
    }

    openModal = (modal, cancel1, tipo) => () => {
        tipoNota = tipo
        this.setState ({
            [modal]: true,
            [cancel1]: false,
            openReporte: false,
        })
    }

    render() {
        let { datos } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let MenuContent = (tipo) => (
            <Popover bsSize="large" id="menuItems">
                <div className="text-primary" onClick={this.openModal("openOk", "openCancel", tipo)} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-check"></i> Aprobar e Imprimir</div>
                <div className="text-warning" onClick={this.openModal("openOkE", "openCancel", tipo)} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-check"></i> Aprobar y Editar</div>
                <div className="text-danger" onClick={this.openModal("openCancel", "openOk", tipo)} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-times"></i> Cancelar Solicitud</div>
                {/* <div className="text-warning" style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-file-o"></i> Archivo Histórico</div> */}
            </Popover>
        )

        let tipoSolicitud = (tipo) => {
            if (tipo === 1) return "CERTIFICADA";
            return "SIMPLE"
        }

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{`${datos.nacionalidad} ${datos.ci}`}</td>
                    <td style={styles}>{nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</td>
                    <td align="center" style={styles}>{datos.carrera_name}</td>
                    <td align="center" style={styles}>{tipoSolicitud(datos.certificada)}</td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={MenuContent(datos.certificada)}>
                            <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalCancel()}
                {this.modalOk()}
                {this.modalOkE()}
                {this.modalReporte()}
                {this.modalReporteE()}
            </React.Fragment>
        );
    }
}
 
export default NotasPendientes;


// WEBPACK FOOTER //
// ./src/views/Reportes/NotasCertContent/NotasPendientes.jsx